import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVanillaReaderUiDialogResult} from "./VanillaReaderUiModel";

export interface VanillaReaderUiDialogFootnoteController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
* # VanillaReaderUiDialogFootnoteController
*
* ## RESPONSIBILITIES
* This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogFootnote` class.
*
* Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
* in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
*
* ## RELATED TYPES
* - VanillaReaderUi
* - VanillaReaderUiDialogFootnote
*
* */
export class VanillaReaderUiDialogFootnoteController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogFootnote.onGotoFootnoteButtonClicked(vanillaReaderUiContext._onDialogFootnoteButtonGotoFootnoteClicked.bind(vanillaReaderUiContext));
    }

    _onDialogFootnoteButtonGotoFootnoteClicked(locator: string): void {
        if (locator) {
            this.navigateTo(locator, true);
        }

        this.dialogFootnote.close(true, false);
    };

    _onDialogFootnoteClosed(result: IVanillaReaderUiDialogResult<string>): void {
        if (result.data) {
            this.navigateTo(result.data, true);
        }
    };

}
